module.exports = __webpack_public_path__ + "img/xlsx.dddde11e.svg";